import { useMutation } from "@tanstack/react-query";

import { apiPostBindTelegram } from "../service";

export const usePostBindTelegram = (options) => {
  return useMutation(
    (params) =>
      apiPostBindTelegram(params).then((res) => {
        return res.data.data;
      }),
    {
      onError: (error) => {
        console.debug(JSON.stringify("ERR", error));
      },
    },
  );
};
